module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Foreword#for"
    }
  }, [_c('i', [_vm._v("Foreword")]), _vm._v(" by Rick Warren")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "pre1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface001#pre"
    }
  }, [_c('i', [_vm._v("Preface to the Third Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "pref1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface002#pref"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Right Approach")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part001#pt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part001#pt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Christ Is")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Claims of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Character of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Resurrection of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pat1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part002#pat",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part002#pat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What We Need")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Fact and Nature of Sin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Consequences of Sin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt3_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part003#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part003#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Christ Has Done")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Death of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("The Salvation of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt4_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Part004#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part004#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Respond")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Counting the Cost")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Reaching a Decision")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Being a Christian")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "que1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Questions#que",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Study Questions")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ind1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Scripture Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 66
// module chunks = 0